import Layout from '../../components/ui/Layout';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import { toast } from '../../components/ui/Toast';
import { IconBell, IconCheck } from '@tabler/icons-react';
import { useState } from 'react';

export default function ProfileNotifications() {
  const [pushEnabled, setPushEnabled] = useState(true);
  const [emailEnabled, setEmailEnabled] = useState(true);

  return (
    <Layout>
      <div style={{ padding: 'var(--main-padding)', maxWidth: 560, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24 }}>
          <IconBell size={20} color="var(--color-text-secondary)" stroke={1.5} />
          <h1 style={{ fontSize: 22, fontWeight: 400 }}>Notifications</h1>
        </div>
        <Card style={{ marginBottom: 20 }}>
          {[
            { key: 'push', label: 'Push notifications', description: 'Receive alerts on your device', value: pushEnabled, set: setPushEnabled },
            { key: 'email', label: 'Email notifications', description: 'Receive summaries by email', value: emailEnabled, set: setEmailEnabled },
          ].map((setting, i, arr) => (
            <div key={setting.key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 0', borderBottom: i < arr.length - 1 ? '0.5px solid var(--color-border-light)' : 'none' }}>
              <div>
                <div style={{ fontSize: 13, color: 'var(--color-text-primary)' }}>{setting.label}</div>
                <div style={{ fontSize: 11, color: 'var(--color-text-tertiary)', marginTop: 2 }}>{setting.description}</div>
              </div>
              <div
                onClick={() => setting.set(!setting.value)}
                style={{ width: 42, height: 24, borderRadius: 12, background: setting.value ? 'var(--color-brand)' : 'var(--color-bg-tertiary)', position: 'relative', cursor: 'pointer', transition: 'background 0.2s', flexShrink: 0 }}
              >
                <div style={{ width: 18, height: 18, borderRadius: '50%', background: '#fff', position: 'absolute', top: 3, left: setting.value ? 21 : 3, transition: 'left 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.15)' }} />
              </div>
            </div>
          ))}
        </Card>
        <Button variant="primary" icon={<IconCheck size={14} stroke={1.5} />} onClick={() => toast.success('Preferences saved')}>
          Save preferences
        </Button>
      </div>
    </Layout>
  );
}